export const P00037PositionTypeEnum = [
  { ref: 0, label: 'P00037.positiontype.0' },
  { ref: 1, label: 'P00037.positiontype.1' },
];
